import { useTranslation } from "react-i18next";
import {
  faBell,
  faCalendar,
  faGear,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./style.css";

function Index() {
  const { t } = useTranslation("menu");

  const menuConfig = [
    { key: "home", icon: faHome, link: "/home", dis: "translate-x-0" },
    {
      key: "calender",
      icon: faCalendar,
      link: "/calendar",
      dis: "translate-x-16",
    },
    {
      key: "notification",
      icon: faBell,
      link: "/notifications",
      dis: "translate-x-32",
    },
    {
      key: "setting",
      icon: faGear,
      link: "/settings",
      dis: "translate-x-48",
    },
  ];

  const menus = menuConfig.map((item) => ({
    ...item,
    label: t(item.key),
  }));

  const location = useLocation();
  const { pathname } = useLocation();
  const [active, setActive] = useState(
    menus.findIndex((x) => x.link === pathname)
  );

  useEffect(() => {
    setActive(menus.findIndex((x) => x.link === pathname));
  }, [pathname, menus]);

  return (
    <div className="md:hidden flex justify-center fixed bottom-0 w-full bg-white dark:bg-dark-bg left-0 z-20 h-16 bottom-navbar">
      <div className="flex text-gray-600 dark:text-dark-text relative justify-around w-full px-0">
        {/* {menus[active] && (
          <span
            className={`bg-primaryColor border-8 border-white h-16 w-16 absolute -top-5 rounded-full duration-500 ${menus[active]?.dis}`}
          ></span>
        )} */}
        {[
          { to: "/home", label: "home", icon: "home" },
          { to: "/calendar", label: "menu.calander", icon: "calendar" },
          {
            to: "/notifications",
            label: "menu.notifications",
            icon: "notifications",
          },
          { to: "/settings", label: "menu.settings", icon: "settings" },
        ].map(({ to, label, icon }) => {
          const active = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              // title={t(label, label === 'notification' ? 'Notification' : undefined)}
              className="relative flex items-center justify-center"
            >
              <img
                src={`/${icon}${active ? "_blue.svg" : "_white.svg"}`}
                alt={label}
                width={30}
                height={30}
                className="w-[30px] h-[30px] block select-none"
                draggable={false}
              />
              {active && (
                <span
                  className="absolute bottom-1 left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-[#6D29F6] rounded-full ring-2 ring-white dark:ring-dark-bg"
                  aria-hidden="true"
                />
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}

export default Index;
